import React from "react";
import RelationshipListCard from "./RelationshipListCard";
import SearchBar from "@/shared/components/ui/SearchBar/SearchBar";
import { getCleanName } from "@/shared/utils/accountConfig";

const MappingListSidebar = ({
  relationshipMapping,
  selectedMappingContact,
  setSelectedMappingContact,
  height,
  searchQuery,
  setSearchQuery,
  isSearching = false,
}) => {
  return (
    <div className="w-[22%] flex flex-col gap-1 border border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-l-2xl relative">
      <div className="flex w-full items-center gap-2 p-4">
        <SearchBar
          placeholder={`Search contacts from ${getCleanName(relationshipMapping?.company_name)}`}
          value={searchQuery}
          setFilterValue={setSearchQuery}
          onChange={setSearchQuery}
        />
      </div>
      {/* list */}
      <div
        className="w-full font-sans overflow-auto border-t border-gray-200 dark:border-gray-800"
        style={{
          height: `calc(${height} - 72px)`,
        }}
      >
        {isSearching && !relationshipMapping?.contacts?.length ? (
          <p className="text-xs text-gray-500 px-2 py-4">Searching...</p>
        ) : relationshipMapping?.contacts?.length ? (
          relationshipMapping.contacts.map((contact, index) => (
            <RelationshipListCard
              key={contact.relationship_mapping_id}
              contact={contact}
              isSelected={
                selectedMappingContact?.relationship_mapping_id ===
                contact.relationship_mapping_id
              }
              onSelect={() => setSelectedMappingContact(contact)}
              isLastItem={index === relationshipMapping.contacts.length - 1}
            />
          ))
        ) : (
          <p className="text-xs text-gray-500 px-2 py-4">
            No contacts found for this account.
          </p>
        )}
      </div>
    </div>
  );
};

export default MappingListSidebar;
